module.exports = __webpack_public_path__ + "static/android-icon-192x192-37160a52b62f5ea31c810879c4e5da12.png";